import { WIDGET_CONTAINER } from '../../../../types/types';
//import useAuth from '../../../../hooks/auth-hooks';
import { ITerminal, TerminalCardGroup } from '../../../../models/terminal.interface';
import { ITax } from '../../../../models/taxes.interface';

/**
 * Function that displays the associated card groups widget on the right of the form
 * 
 * @param {object} terminalData the terminal data object
 * @param {object} cardGroupData the card group object
 */
export const displayCardGroupWidget = (terminalData: ITerminal[], cardGroupData: TerminalCardGroup[]) => {
  const { partnerId, terminalId } = terminalData[0];

  const fragment = document.createDocumentFragment();

  const widgetCon = document.createElement('div');
  widgetCon.className = 'aafp_widget aafp_border-radius';

  const widgetTitle = document.createElement('h3');
  widgetTitle.innerText = 'Card Groups';

  const widgetBodyContainer = document.createElement('div');
  widgetBodyContainer.className = 'aafp_widget-container';

  const widgetBody = document.createElement('div');
  widgetBody.className = 'aafp_widget-container-body';

  const cardGroupDataLength = Object.keys(cardGroupData).length;
  const widgetBodyText = document.createElement('span');
  widgetBodyText.innerText = cardGroupDataLength === 0
    ? 'There are no Card Groups setup with this terminal. Please follow the link below to add one.'
    : 'Please follow the link below to view Card Groups associated with this terminal.';

  const widgetFooter = document.createElement('div');
  widgetFooter.className = 'aafp_widget-container-footer';

  const widgetFooterLink = document.createElement('a');
  widgetFooterLink.className = 'aafp_btn-form btn_theme-primary mt-3';
  widgetFooterLink.href = `/terminal-card-group?linkAction=terminal&partnerID=${partnerId}&terminalID=${terminalId}`;
  widgetFooterLink.innerText = cardGroupDataLength === 0 ? 'SETUP' : 'VIEW';

  widgetFooter.appendChild(widgetFooterLink);
  widgetBody.appendChild(widgetBodyText);
  widgetBodyContainer.appendChild(widgetBody);
  widgetBodyContainer.appendChild(widgetFooter);
  widgetCon.appendChild(widgetTitle);
  widgetCon.appendChild(widgetBodyContainer);  
  fragment.appendChild(widgetCon);
  WIDGET_CONTAINER.appendChild(fragment);
}

/**
 * Function that displays the associated tax widget on the right of the form
 * 
 * @param {object} terminalData the terminal data object
 * @param {object} taxData the tax object
 */
export const displayTaxWidget = (terminalData: ITerminal[], taxData: ITax[]) => {
  //const { accessType } = useAuth()!;
  const { partnerId, terminalId } = terminalData[0];

  const fragment = document.createDocumentFragment();
  
  const widgetCon = document.createElement('div');
  widgetCon.className = 'aafp_widget aafp_border-radius';

  const widgetTitle = document.createElement('h3');
  widgetTitle.innerText = 'Taxes';

  const widgetBodyContainer = document.createElement('div');
  widgetBodyContainer.className = 'aafp_widget-container';

  const widgetBody = document.createElement('div');
  widgetBody.className = 'aafp_widget-container-body';

  const taxDataLength = Object.keys(taxData).length;
  const widgetBodyText = document.createElement('span');
  widgetBodyText.className = 'mb-2';
  widgetBodyText.innerText = taxDataLength === 0 
    ? 'There are no default taxes associated with this terminal.' 
    : 'Please follow the link below to view Default Taxes associated with this terminal.';

  const widgetFooter = document.createElement('div');
  widgetFooter.className = 'aafp_widget-container-footer';

  const widgetFooterLink = document.createElement('a');
  widgetFooterLink.className = 'aafp_btn-form btn_theme-primary mt-3';
  widgetFooterLink.href = `/terminals/link-terminal-tax?linkAction=Add&partnerID=${partnerId}&terminalID=${terminalId}`;
  widgetFooterLink.innerText = taxDataLength === 0  ? 'SETUP' : 'VIEW';

  //if ( accessType === 'E' ) {
    widgetFooter.appendChild(widgetFooterLink);
  //}
  
  widgetBody.appendChild(widgetBodyText);
  widgetBodyContainer.appendChild(widgetBody);
  widgetBodyContainer.appendChild(widgetFooter);
  widgetCon.appendChild(widgetTitle);
  widgetCon.appendChild(widgetBodyContainer);  
  fragment.appendChild(widgetCon);
  WIDGET_CONTAINER.appendChild(fragment);
}